import React, { Fragment } from 'react'
import { Container, Row } from 'reactstrap'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { EditProfileTitle, UserProfileTitle, UsersTitle } from '../../../../Utils/Constants'
import MyProfile from './MyProfile'
import EditProfile from './EditProfile'
import AddProjectsAndUpload from './AddProjectsAndUpload'
import UserProfiles from '../UserProfiles'

export default function EditProfileContainer() {
     const empId = localStorage.getItem('empId')
      const empIdNumber = empId ? parseInt(empId, 10) : undefined;
    return (
        
                <div className=" ">
                   
                        {/* <MyProfile />
                        <EditProfile/> */}
                    <UserProfiles employeeIdProp={empIdNumber} />

                    
                </div>
       
    )
}
